export default __webpack_public_path__ + "images/cu-ff35f996902731bad2871a6163a8b426.svg";